import { apiConfig, appConfig } from 'config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { fetchPolygonData } from 'apis/FetchPolygons';

export function createDeviceGroup(deviceGroupName, isDefault = false, devices = []) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };

  let body = {
    format: 'static',
    data: {
      name: deviceGroupName,
      default: isDefault,
      devices
    }
  };

  return fetchdata(apiConfig.deviceGroupsPostDeviceGroup, {
    method: 'POST',
    body: JSON.stringify(body),
    headers
  }).catch((e) => {
    console.log('create device group error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function updateDeviceGroup(deviceGroupId, deviceGroupName, isDefault, devices = []) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };

  let body = {
    name: deviceGroupName,
    default: isDefault,
    devices
  };

  return fetchdata(apiConfig.deviceGroupsUpdateDeviceGroup(deviceGroupId), {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers
  }).catch((e) => {
    console.log('update device group error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function deleteDeviceGroup(deviceGroupId) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };
  const url = apiConfig.deviceGroupsDeleteDeviceGroup(deviceGroupId);

  return fetch(url, { method: 'DELETE', headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          console.log(e);
          throw Error('Delete Device Group Failed');
      }
    });
}

export function undoDeviceGroupDeletion(deviceGroupId) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };
  const url = apiConfig.deviceGroupsUndoDeviceGroupDeletion(deviceGroupId);

  return fetch(url, { method: 'PATCH', headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          console.log(e);
          throw Error('Undo Deleted Device Group Failed');
      }
    });
}

export function getAllUserDeviceGroups() {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };
  let url = apiConfig.deviceGroupsSearchUserGroups;

  return fetchdata(url, { method: 'GET', headers }).catch((e) => {
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function getAllUserDevicePolygons() {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + localStorage.getItem('accessToken')
  };
  let url = apiConfig.deviceGroupsSearchGeoPolygons;
  return fetchPolygonData(url, { method: 'GET', headers }).catch((e) => {
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function duplicateDeviceGroupPolygon(deviceGroupId) {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + localStorage.getItem('accessToken')
  };

  const body = { id: deviceGroupId };

  return fetchPolygonData(apiConfig.deviceGroupsDuplicateDeviceGroup, {
    method: 'POST',
    body: JSON.stringify(body),
    headers
  }).catch((e) => {
    console.log('polygon duplicate error = ' + e.statusText);
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function createDeviceGroupPolygon(format, data) {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + localStorage.getItem('accessToken')
  };

  const body = { format, data };

  return fetchPolygonData(apiConfig.deviceGroupsPostDeviceGroup, {
    method: 'POST',
    body: JSON.stringify(body),
    headers
  }).catch((e) => {
    console.log('create device group error = ' + e.statusText);
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function updateDeviceGroupPolygon(deviceGroupId, data) {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + localStorage.getItem('accessToken')
  };

  return fetchPolygonData(apiConfig.deviceGroupsUpdateDeviceGroup(deviceGroupId), {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers
  }).catch((e) => {
    console.log('update device group error = ' + e.statusText);
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function importDeviceGroupPolygon(file) {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    'content-type': 'multipart/form-data',
    Origin: `${appConfig.webBaseUrl}/`,
    Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    mode: 'cors'
  };

  return fetchPolygonData(apiConfig.deviceGroupsImportGeoPolygon, {
    method: 'POST',
    body: file,
    headers
  }).catch((e) => {
    console.log('create device group error = ' + e.statusText);
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function exportDeviceGroupPolygon(deviceGroupId) {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Origin: `${appConfig.webBaseUrl}/`,
    Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    mode: 'cors'
  };

  return fetchPolygonData(apiConfig.deviceGroupsExportGeoPolygon(deviceGroupId), {
    method: 'GET',
    headers
  }).catch((e) => {
    console.log('create device group error = ' + e.statusText);
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function sortUserDevicePolygons(data) {
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + localStorage.getItem('accessToken')
  };

  return fetchPolygonData(apiConfig.deviceGroupsSortGeoPolygons, {
    method: 'POST',
    body: JSON.stringify(data),
    headers
  }).catch((e) => {
    console.log('create device group error = ' + e.statusText);
    switch (e.status) {
      case 420:
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}